// components/Notifications.js
import React, { forwardRef } from "react";
import { Bell, Check, X, Clock, User, CreditCard, Book, Settings } from "lucide-react";
import "../../styles/notificationspanel.css";

const NotificationsPanel = forwardRef(({
    notifications,
    unreadCount,
    onMarkAsRead,
    onMarkAllAsRead,
    onClose
}, ref) => {

    const getNotificationIcon = (type) => {
        switch (type) {
            case 'student': return <User size={16} />;
            case 'payment': return <CreditCard size={16} />;
            case 'course': return <Book size={16} />;
            case 'system': return <Settings size={16} />;
            default: return <Bell size={16} />;
        }
    };

    const getNotificationClass = (type) => {
        switch (type) {
            case 'student': return 'notification-student';
            case 'payment': return 'notification-payment';
            case 'course': return 'notification-course';
            case 'system': return 'notification-system';
            default: return '';
        }
    };

    return (
        <div className="notifications-panel-container">
            <div className="notifications-header">
                <div className="notifications-title">
                    <Bell size={20} />
                    <h3>Notifications</h3>
                    {unreadCount > 0 && (
                        <span className="unread-count-badge">{unreadCount} new</span>
                    )}
                </div>
                <div className="notifications-actions">
                    <button className="close-notifications-btn" onClick={onClose}>
                        <X size={20} />
                    </button>

                </div>

            </div>

            <div className="notifications-list">
                {notifications.length === 0 ? (
                    <div className="no-notifications">
                        <Bell size={40} />
                        <p>No notifications</p>
                    </div>
                ) : (
                    notifications.map(notification => (
                        <div
                            key={notification.id}
                            className={`notification-item ${getNotificationClass(notification.type)} ${!notification.read ? 'unread' : ''
                                }`}
                            onClick={() => {onMarkAsRead(notification.id)
                            }
                            }
                        >
                            <div className="notification-icon">
                                {getNotificationIcon(notification.type)}
                            </div>
                            <div className="notification-content">
                                <div className="notification-header">
                                    <h4 className="notification-title">{notification.title}</h4>
                                    {!notification.read && (
                                        <span className="unread-dot"></span>
                                    )}
                                </div>
                                <p className="notification-message">{notification.message}</p>
                                <div className="notification-footer">
                                    <Clock size={12} />
                                    <span className="notification-time">{notification.time}</span>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

        </div>
    );
});

NotificationsPanel.displayName = 'NotificationsPanel';

export default NotificationsPanel;